"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlVec2Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float vector2 uniform.
 */
class GlVec2Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform2fv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlVec2Uniform = GlVec2Uniform;
//# sourceMappingURL=gl-vec2-uniform.js.map